import {get} from 'lodash-es'
import {detect} from 'detect-browser'
import {toBase64} from 'pvutils'

import {
  ExportableNoPassword,
  HardwareTokenType,
  InitializationErrorCode,
  InitializationErrorMessage,
  KeyStoreFriendlyNameMap,
  KeyStoreID,
  keyStoreIdToHardwareTokenType,
  KeyStoreLocation,
  NoExportNoPassword,
  notHardwareKeyStoreIds
} from './ddc.constants'
import {DDCProfile, KeyStore, SecurityPolicy, WebCertificate} from './ddc.types'


import {DDCSettings} from 'reducers/Reducers.interfaces'
import PKIUtils from 'secure-pages/client-auth/certificate/pki/PKIUtils'
//import { getTemplateFieldValueByKey } from 'secure-pages/profiles/profile-form/ProfileForm.helpers'
//import { KEY_SIZE_FIELD } from 'secure-pages/profiles/profile-form/ProfileForm.constants'

export class DDC {
  static accessToken: string =
    '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'
  static alison = null as any
  static initialized = false

  static async initialize() {
    if (DDC.alison && DDC.initialized) {
      return Promise.resolve(DDC.alison)
    }

    //@ts-ignore
    DDC.alison = new AlisonJS.Desktop()

    return await DDC.alison.initialize({ accessToken: DDC.accessToken }).then(
      () => {
        DDC.initialized = true

        return DDC.alison
      },
      async error => {
        if (error.code === InitializationErrorCode) {
          const isRunning = await DDC.alison.isRunning()
          if (!isRunning) throw InitializationErrorMessage.notRunning

          const isEnabled = await DDC.alison.isEnabled()
          if (!isEnabled) throw InitializationErrorMessage.disabled

          throw InitializationErrorMessage.genericError
        }

        throw error
      }
    )
  }

  // works only with AlisonJS 3.1.0 and above
  static async getProfilesList(): Promise<any[]> {
    await DDC.initialize()

    return await DDC.alison.listProfiles().then(data => data.profiles)
  }

  static async getProfilesForKeystore(keyStoreId: KeyStoreID): Promise<any[]> {
    const allProfiles = await DDC.getProfilesList()

    return allProfiles.filter(profile => profile.keyStoreId === keyStoreId)
  }

  static async getCertificateList(): Promise<WebCertificate[]> {
    await DDC.initialize()

    return await DDC.alison.certificateList().then(data => data.certificates)
  }

  static async getCertificatesForKeyStore(keyStoreId: KeyStoreID): Promise<WebCertificate[]> {
    const certificates = await DDC.getCertificateList()

    return certificates.filter(certificate => certificate.cert.keyStoreId === keyStoreId)
  }

  // to be moved to some project specific place
  static async getCertificatesForHardwareTokensBasedOnProfile(
    hardwareTokenTypes: HardwareTokenType[]
  ): Promise<WebCertificate[]> {
    const certificates = await DDC.getCertificateList()
    const availableKeyStores = await DDC.getAvailableHardwareKeyStoresBasedOnProfileData(
      hardwareTokenTypes
    )

    return certificates.filter(certificate =>
      availableKeyStores.find(keyStore => certificate.cert.keyStoreId === keyStore.id)
    )
  }

  static async getAllKeyStores(): Promise<KeyStore[]> {
    await DDC.initialize()

    const { keyStores } = await DDC.alison.listKeyStores()

    return keyStores
  }

  // to be moved to some project specific place
  static async findCertificateBySerialNumberBasedOnDDCSettings(
    ddcSettings: DDCSettings,
    serialNumber: string
  ): Promise<{ certificate: WebCertificate; keyStore: KeyStore }> {
    const isHardwareToken = get(ddcSettings, 'keystore_location') === KeyStoreLocation.HardwareToken
    const hardwareTokenTypes = get(ddcSettings, 'hardware_token_type', [])
    let certificateList
    let keyStore

    if (isHardwareToken) {
      certificateList = await DDC.getCertificatesForHardwareTokensBasedOnProfile(hardwareTokenTypes)
    } else {
      keyStore = await DDC.getCurrentBrowserKeyStore()
      certificateList = await DDC.getCertificatesForKeyStore(keyStore.id)
    }

    const certificate = certificateList.find(
      certificate => certificate.cert.serialNumberH === serialNumber
    )

    if (isHardwareToken) {
      keyStore = await DDC.getKeyStoreById(certificate.cert.keyStoreId)
    }

    if (!certificate) {
      throw { keyStoreName: KeyStoreFriendlyNameMap[keyStore.id] || keyStore.friendlyName }
    }

    return { certificate, keyStore }
  }

  static async getAvailableKeyStores(): Promise<KeyStore[]> {
    const allKeyStores = await DDC.getAllKeyStores()

    return allKeyStores.filter(keyStore => keyStore.status.resultStatus === 0)
  }

  static async getAvailableHardwareKeyStores(): Promise<KeyStore[]> {
    const availableKeyStores = await DDC.getAvailableKeyStores()
    const availableProfiles = await DDC.getProfilesList()
    const availableHardwareKeyStores = availableKeyStores.filter(
      keyStore => !notHardwareKeyStoreIds.includes(keyStore.id)
    )

    return availableHardwareKeyStores.filter(keyStore =>
      availableProfiles.find(profile => profile.keyStoreId === keyStore.id)
    )
  }

  static async getAvailableHardwareProfiles(): Promise<DDCProfile[]> {
    const availableProfiles = await DDC.getProfilesList()
    return availableProfiles.filter(
      profile => !notHardwareKeyStoreIds.includes(profile.keyStoreId)
    )
  }

  // to be moved somewhere project specific, TO BE DELETED
  static async getAvailableHardwareKeyStoresBasedOnProfileData(
    hardwareTokenTypes: HardwareTokenType[]
  ): Promise<KeyStore[]> {
    let availableKeyStores = await DDC.getAvailableHardwareKeyStores()

    if (!hardwareTokenTypes.includes(HardwareTokenType.ALL)) {
      availableKeyStores = availableKeyStores.filter(keyStore =>
        hardwareTokenTypes.includes(keyStoreIdToHardwareTokenType[keyStore.id])
      )
    }

    return availableKeyStores
  }

  // to be moved to some project specific place
  static async getAvailableHardwareProfilesBasedOnProfileData(
    hardwareTokenTypes: HardwareTokenType[]
  ): Promise<DDCProfile[]> {
    let availableProfiles = await DDC.getAvailableHardwareProfiles()

    if (!hardwareTokenTypes.includes(HardwareTokenType.ALL)) {
      availableProfiles = availableProfiles.filter(profile =>
        hardwareTokenTypes.includes(keyStoreIdToHardwareTokenType[profile.keyStoreId])
      )
    }

    return availableProfiles
  }

  static async getKeyStoreById(keyStoreId: KeyStoreID): Promise<KeyStore> {
    const keyStores = await DDC.getAvailableKeyStores()

    return keyStores.find(keyStore => keyStore.id === keyStoreId) as KeyStore
  }

  // to be moved to some project specific place
  static getCurrentBrowserKeyStoreId(): KeyStoreID {
    const browser = detect()
    const name = get(browser, 'name', '')
    const os = get(browser, 'os')

    if (name === 'firefox') {
      return KeyStoreID.FF_NSS
    } else {
      if (os) {
        if (os.includes('Mac')) return KeyStoreID.MACOS
        if (os.includes('Win')) return KeyStoreID.WIN_ENH
      }

      throw 'No keystore for current browser or platform'
    }
  }

  static async getCurrentBrowserKeyStore(): Promise<KeyStore> {
    const keyStoreId = DDC.getCurrentBrowserKeyStoreId()

    return await DDC.getKeyStoreById(keyStoreId)
  }

  // to be moved somewhere project specific
  static async getCurrentKeyStoreIdAndSecurityPolicy(
    exportPrivateKey: boolean
  ): Promise<{ keyStoreId: KeyStoreID; securityPolicy: any }> {
    const keyStoreId = DDC.getCurrentBrowserKeyStoreId()
    let securityPolicy = {}

    if (keyStoreId === KeyStoreID.WIN_ENH) {
      securityPolicy = exportPrivateKey ? ExportableNoPassword : NoExportNoPassword
    }

    return { keyStoreId, securityPolicy }
  }

  static async generateCSRBasedOnProfile(
    predefinedKeyStoreId: KeyStoreID,
    isHardwareToken: boolean,
    predefinedKeyStoreProfileName?: string
  ): Promise<{
    csr: string
    keyStoreId: KeyStoreID
    securityPolicy: any
    profileName: string
  }> {

    let csr
    let keyStoreId
    let securityPolicy
    let profileName

    //const key = getTemplateFieldValueByKey(profile.fields, KEY_SIZE_FIELD) as string
    const key = 'RSA 2048'
    if (!isHardwareToken) {
      const exportPrivateKey = false
      const resp = await DDC.getCurrentKeyStoreIdAndSecurityPolicy(exportPrivateKey)

      csr = await DDC.generateBrowserCSR(
        key,
        false
      )
      keyStoreId = resp.keyStoreId
      securityPolicy = resp.securityPolicy
    } else {
      csr = await DDC.generateCSRForHardwareToken(
        predefinedKeyStoreId,
        key,
        predefinedKeyStoreProfileName
      )
      keyStoreId = predefinedKeyStoreId
      profileName = predefinedKeyStoreProfileName
    }

    return { csr, keyStoreId, securityPolicy, profileName }
  }

  static async generateCSR(
    keyStoreID: KeyStoreID,
    options?: {
      algorithm?: string
      size?: number
      signatureAlgorithm?: string
    },
    securityPolicy?: SecurityPolicy,
    profileName?: string
  ): Promise<string> {
    await DDC.initialize()

    const { csr } = await DDC.alison.generateCsr({
      keyStore: { id: keyStoreID, profile: profileName },
      options,
      securityPolicy
    })

    return csr
  }

  // to be moved somewhere project specific
  static async generateBrowserCSR(
    key: string,
    exportPrivateKey: boolean,
    profileName?: string
  ): Promise<string> {
    const [keyType, keySize] = key.split(' ')

    const { keyStoreId, securityPolicy } = await DDC.getCurrentKeyStoreIdAndSecurityPolicy(
      exportPrivateKey
    )

    return await DDC.generateCSR(keyStoreId, { size: Number(keySize) }, securityPolicy, profileName)
  }

  static async generateCSRForHardwareToken(
    keystoreId: KeyStoreID,
    key: string,
    profileName?: string
  ): Promise<string> {
    const [keyType, keySize] = key.split(' ')
    return await DDC.generateCSR(keystoreId, { size: Number(keySize) }, {}, profileName)
  }

  static async installPKCS7(
    keyStoreID: KeyStoreID,
    pkcs7: string,
    securityPolicy: SecurityPolicy = {},
    profileName?: string
  ): Promise<WebCertificate> {
    await DDC.initialize()

    return await DDC.alison.installPkcs7({
      keyStore: { id: keyStoreID, profile: profileName },
      pkcs7: PKIUtils.removeHeader(pkcs7),
      securityPolicy
    })
  }

  static async sign(text: string, thumbPrint: string, keyStore: KeyStore): Promise<string> {
    await DDC.initialize()

    return await DDC.alison
      .getSignature({
        dataToSignB64: toBase64(text),
        format: 'NONE',
        algorithm: 'SHA256withRSA',
        signingCertificate: {
          keyStoreId: keyStore.id,
          thumbPrint
        }
      })
      .then(data => data.signature)
  }
}
